export default {
  LIST: {
    TITLE: `Liste des congés`
  },
  FORM: {
    TITLE: ``,
    SUMMARY: ``
  },
  TIME_OFF: `Congés`,
  TIMEOFF_SUMMARY: `<0>{{ name }}</0> - {{ requestTypeName }} <1>({{ range }})</1>`,
  NO_TIMEOFF_TO_SHOW: `Aucun congé à afficher.`,
  IMPORT_TIME_OFF: `Importer des congés`,
  CREATE: `Créer un congé`,
  IN_PROGRESS: `En cours`,
  APPROVE: `Approuver`,
  APPROVED: `Approuvé`,
  REFUSED: `Refusé`,
  CANCELLED: `Annulé`,
  IN_PROGRESS_MARKED: `Mis en cours`,
  APPROVED_MARKED: `Approuvé`,
  REFUSED_MARKED: `Refusé`,
  CANCELLED_MARKED: `Annulé`,
  STATUS: `Statut`,
  MANAGEMENT: `Gestion`,
  FIRST_COLUMN: ``,
  SECOND_COLUMN: ``,
  CREATED_BY_ON: `Créé par <0>{{createdBy}}</0> le {{date}} à <2>{{time}}</2>`,
  STATUS_PHRASE: `<0>{{status}}</0> par <1>{{validateBy}}</1> le {{date}} à <3>{{time}}</3>`,
  COMMENT: `<0>{{count}} commentaire <2/></0>`,
  COMMENT_other: `<0>{{count}} commentaires <2/></0>`,
  TIME_OFFS_THIS_YEAR: `{{count}} congés cette année`,
  SEE_ALL_TIME_OFF: `Afficher toutes les requêtes de congé`,
  IS_LOADING_TIME_OFF: `Chargement des congés`,
  NO_CONFLICTS: `Il n'y a pas de conflits d'horaire`,
  IS_LOADING_CONFLICTS: `Chargement des conflits d'horaire.`,
  CONFLICTS_DURING_TIME_OFF: `{{count}} conflits durant la demande de congé.`,
  SEE_ALL_SCHEDULE_CONFLICTS: `Afficher les conflits d'horaire`,
  SEE_TIMEOFF_CONFIRMATION_STATUS: `Voir le statut de notification du congé`,
  TIMEOFF_CONFIRMATION_STATUS_MODAL: {
    TITLE: `Statut de notification du congé`,
    SUMMARY: ``
  },
  DELETE: {
    TITLE: `Supprimer la requête de congé`,
    SUMMARY: `Etes-vous certain de vouloir supprimer la requête de congé ?`,
    PRIMARY_ACTION: `Supprimer la requête`
  },
  csv: {
    TIMEOFF_CSV_NAME: `export_conge_{{date}}`,
    REQUEST_DATE: `Date de la requête`,
    CREATED_BY: `Créée par`,
    VALIDATION_DATE: `Date de validation`,
    VALIDATED_BY: `Validée par`,
    START: `Début`,
    END: `Fin`,
    DATE: `Date`,
    VACATION_TYPE: `Type de congé`,
    COMMENTS: `Commentaires`,
    PRIMARY_OCCUPATION: `Assignation primaire`,
    SECONDARY_OCCUPATION: `Assignation secondaire`,
    EMPLOYEE_NUMBER: `Numéro d'employé`,
    EMPLOYEE: `Employé`,
    STATUS: `Statut de la requête`
  },
  form: {
    CREATE: {
      TITLE: `Créer une requête de congé`
    },
    EDIT: { TITLE: `Modifier la requête de congé` },
    VACATIONTYPEID: {
      LABEL: `Type de congé`,
      DESCRIPTION: ``
    },
    VIEW: {
      TITLE: `Voir une requête de congé`,
      SUMMARY: ``
    },
    COMMENT: {
      LABEL: `Commentaire`,
      PLACEHOLDER: `Écrivez un commentaire`,
      DESCRIPTION: ``
    },
    USERID: {
      LABEL: `Employé`,
      DESCRIPTION: ``
    },
    PARTIALDATES: {
      LABEL: `Dates partielles`,
      DESCRIPTION: `Permet de mettre une heure de fin et de début, plutôt que des dates complètes.`
    },
    START: { LABEL: `Début`, PLACEHOLDER: ``, DESCRIPTION: `` },
    END: { LABEL: `Fin`, PLACEHOLDER: ``, DESCRIPTION: `` },
    COMMENT_REQUIRED: `Un commentaire est requis.`,
    REQUEST_TYPE_ID_REQUIRED: `Veuillez sélectionner un type de congé.`,
    START_REQUIRED: `Veuillez sélectionner une date de début.`,
    END_REQUIRED: `Veuillez sélectionner une date de fin.`,
    USER_REQUIRED: `Veuillez sélectionner un employé.`,
    SUBMIT: `Soumettre`,
    QUIT_PAGE: `Les modifications apportées n'ont pas été sauvegardées. Souhaitez vous quitter quand même?`,
    END_BEFORE_START: `La date de fin doit être après la date de début.`,
    START_END_MUST_BE_DIFFERENT: `La date de début et de fin doivent être différentes.`,
    SET_PARTIAL_DAYS: `Dates partielles`,
    SET_PARTIAL_DAYS_DESC: `Permet de mettre une heure de fin et de début, plutôt que des dates complètes.`,
    REQUEST_OVERLAPPING_ANOTHER: `La dates entrées chevauchent celles d'une requête de congé déjà existante pour cet employé.`,
    TIMEPAID: {
      LABEL: `Heures payées`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    }
  },
  import: {
    LINE: `Ligne`,
    VALIDATION: `Validation`,
    TITLE: {
      TITLE: `Importation de congé`,
      SUMMARY: `Tous les congés déjà présents dans l'application et qui sont dans la période d'importation seront supprimés.`
    },
    EMPLOYEE_NUMBER: `Numéro d'employé`,
    EMPLOYEENUMBER_DESC: `Le numéro de l'employé dans Merinio.`,
    REQUEST_TYPE: `Type de requête`,
    REQUESTTYPE_DESC: `Le code de la requête tel que défini par un administrateur dans les types de requêtes.`,
    START: `Début`,
    STARTDATE_DESC: ` La date de début doit être inscrite dans le format <1>YYYY-MM-DD</1>, par exemple <1>2010-01-30</1> pour le 30 Janvier 2010.`,
    STARTTIME: `Heure de début`,
    STARTTIME_DESC: `L'heure de début doit être inscrite dans le format <1>HH:mm</1>, par exemple <1>14:00</1> pour 14h.`,
    END: `Fin`,
    ENDDATE_DESC: `La date de fin doit être dans le même format que celle du début.`,
    ENDTIME: `Heure de fin`,
    ENDTIME_DESC: `L'heure de fin doit être dans le même format que celle du début.`,
    STATUS: `Statut`,
    DOWNLOAD_TEMPLATE: `Télécharger un modèle de fichier`,
    MISSING_HEADERS: `Entête manquant : <0>{{value}}</0>`,
    MISSING_HEADERS_other: `Entêtes manquants : <0>{{value}}</0>`,
    TEMPLATE_FILE_NAME: `Importation_congé`,
    TIME_OFF_SAVING_FAILED: `Il y a <0>{{count}}</0> congé qui n'a pas été sauvegardé.`,
    TIME_OFF_SAVING_FAILED_other: `Il y a <0>{{count}}</0> congés qui n'ont pas été sauvegardés.`,
    TIME_OFF_NOT_VALID: `Il y a <0>{{count}}</0> congé invalide.`,
    TIME_OFF_NOT_VALID_other: `Il y a <0>{{count}}</0> congés invalides.`
  },
  MULTI_CREATE_MODAL: {
    TITLE: `Créer plusieurs requêtes de congé`,
    SUMMARY: `Pour les utilisateurs ci-dessous`,
    SOME_FAILED: `Une requête n'a pas pu être créée.`,
    SOME_FAILED_other: `{{count}} requêtes n'ont pas pu être créées.`
  }
}
